module.exports = __webpack_public_path__ + "img/journal.80c9de68.svg";